import React from 'react';
import FadeIn from '../marketing/components/FadeIn';

export default function Section({
  id,
  className = '',
  dark = false,
  children,
  containerClass = '',
}) {
  return (
    <section
      id={id}
      className={`py-20 lg:py-32 ${dark ? 'bg-invert-navy text-white' : 'bg-white text-invert-navy'} ${className}`}
    >
      <div className={`max-w-7xl mx-auto px-6 lg:px-8 ${containerClass}`}>
        {children}
      </div>
    </section>
  );
}

export function SectionHeader({
  label,
  title,
  subtitle,
  align = 'center',
  dark = false,
  className = '',
}) {
  const alignClass =
    align === 'center' ? 'text-center mx-auto' : 'text-left';

  return (
    <FadeIn className={`max-w-3xl mb-16 lg:mb-20 ${alignClass} ${className}`}>
      {label && (
        <p className="text-xs font-semibold uppercase tracking-widest text-invert-orange mb-4">
          {label}
        </p>
      )}
      <h2
        className={`text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-tight mb-6 ${
          dark ? 'text-white' : 'text-invert-navy'
        }`}
      >
        {title}
      </h2>
      {subtitle && (
        <p
          className={`text-lg lg:text-xl leading-relaxed ${
            dark ? 'text-slate-300' : 'text-slate-600'
          }`}
        >
          {subtitle}
        </p>
      )}
    </FadeIn>
  );
}
